

class Message {

    send_message(phone,text){
        return `https://wa.me/52${phone}?text=${encodeURIComponent(text)}`
    }
}


export { Message}